import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=10d00fb9&scoped=true&functional=true&"
import script from "./BasePage.vue?vue&type=script&lang=js&"
export * from "./BasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "10d00fb9",
  null
  
)

export default component.exports